import React, { useState, useCallback } from 'react';
import { Link } from 'react-router-dom';

import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";
import particlesConfig from '../../Shared/pr-s-black';

import { SignInPage } from '../../components/ui/sign-in.js';
import { SignUpPage } from '../../components/ui/sign-up.js';

export default function Login() {
  const [view, setView] = useState('signin'); // 'signin' or 'signup'

  const particlesInit = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {
    // Particles loaded callback
  }, []);

  const toggleView = () => {
    setView(view === 'signin' ? 'signup' : 'signin');
  };

  return (
    <div id="login-wrapper" style={{ position: 'relative', overflow: 'hidden' }}>
      <div className="login-container">
        <section className="login-header">
          <div className="particles circle-bg">
            <div className="container">
              <div className="login-content">
                <div className="auth-section">
                  {view === 'signin' ? (
                    <SignInPage onToggleView={toggleView} />
                  ) : (
                    <SignUpPage onToggleView={toggleView} />
                  )}
                </div>
                
              </div>
            </div>

            <Particles id="particles-js" init={particlesInit} loaded={particlesLoaded} options={particlesConfig} />
            
            <div className="gradient-circle"></div>
            <div className="gradient-circle two"></div>
          </div>
        </section>
      </div>
    </div>
  );
}

// change class name
//in login for the add-ons and setups to work..we can add if its an existing custom, if he have creative assets,etc.
//IP adress + form/submission ID ..

//in login theres's 4 (3 later) types of portals..admin (only visible to admin), customer and agencies + Backend test

/// agencies section
//add slidder pour chaque services que l'agence a 1 to 10. 1= i want more clients, 6=i still want clients, but starting to get busy, 10=can't take any additional client)
//kind of a invetory management system
// if at 8,9,10..less clients for now but want drop lower don't los algo points...if fail to deliver order -> lose points

